import Breadcrumb from "../components/Breadcrumb";
import ErrorLayer from "../components/ErrorLayer";


const ErrorPage = () => {
  return (
    <>
        

        {/* Breadcrumb */}
        <Breadcrumb title="404" icon="solar:danger-triangle-outline" />

        {/* ErrorLayer */}
        <ErrorLayer />


       
    </>
  );
};

export default ErrorPage;
